import SoftSignalButton from './SoftSignalButton.component';

export default SoftSignalButton;